<template>
  <div>
    <viewTable
      ref="viewTable"
      :limits="limits"
      :columns-property="columnsProperty"
      :filter="filter"
      module="basic"
      url="vehicles"
      @addOrEdit="addEditHandle"
      @delete="deleteHandle"
      @select="selectHandle"
      @reset="resetHandle"
    >
      <template slot="otherBtn">
        <el-button v-if="limits.printAuth" :disabled="!selection.length" type="primary" @click="printHandle">打印载具条码</el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="载具编号">
            <el-input v-model.trim="filter.vehicleNo" placeholder="请输入载具编号" clearable />
          </el-form-item>
          <el-form-item label="载具名称">
            <el-input v-model.trim="filter.vehicleName" placeholder="请输入载具名称" clearable />
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <VehicleEdit ref="vehicleEdit" @save-success="loadData"></VehicleEdit>
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
import VehicleEdit from "./VehicleEdit";
export default {
  components: { viewTable, VehicleEdit },
  data() {
    return {
      limits: {
        addAuth: this.$auth(246),
        printAuth: this.$auth(247),
        editAuth: this.$auth(249),
        delAuth: this.$auth(250),
        batchDelAuth: this.$auth(248),
      },
      selection: [],
      filter: {
        vehicleNo: "",
        vehicleName: "",
      },
      columnsProperty: [
        {
          tooltip: true,
          key: "vehicleNo",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "vehicleName",
          minWidth: 100,
        },
        {
          tooltip: true,
          key: "cubicUnitName",
          minWidth: 100,
        },
        {
          tooltip: true,
          key: "length",
          width: 80,
          align: "center",
        },
        {
          tooltip: true,
          key: "width",
          width: 80,
          align: "center",
        },
        {
          tooltip: true,
          key: "lengthLimit",
          width: 80,
          align: "center",
        },
        {
          tooltip: true,
          key: "widthLimit",
          width: 80,
          align: "center",
        },
        {
          tooltip: true,
          key: "load",
          width: 80,
          align: "center",
        },
        {
          tooltip: true,
          key: "loadUnitName",
          width: 100,
          align: "center",
        },
        {
          tooltip: true,
          key: "creatorName",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "createTime",
          width: 160,
          align: "center",
        },
        {
          key: "action",
          align: "center",
          width: 140,
          slot: "action",
          fixed: "right",
        },
      ],
    };
  },
  methods: {
    // 查询载具列表
    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },

    // 新增 编辑
    addEditHandle(row) {
      this.$refs.vehicleEdit.open(row);
    },

    // 删除
    deleteHandle(row) {
      this.$http.delete("basic", "vehicles", row.pkId).then((resp) => {
        if (resp.success) {
          this.loadData();
          this.$message.success("删除成功");
          this.selection = [];
        }
      });
    },

    selectHandle(selection) {
      this.selection = selection;
    },

    // 打印载具条码
    printHandle() {
      const routeUrl = this.$router.resolve({
        path: "/vehiclePrint",
        query: {
          params: JSON.stringify(this.selection),
        },
      });
      window.open(routeUrl.href, "_blank");
    },

    // 重置
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
    },
  },
};
</script>
